<template>
  <v-combobox
    color="#04a777"
    type="number"
    hint="Write ID and press enter, use arrows to select chip, press backspace to delete selected chip"
    label="ID"
    class="search-box"
    append-icon=""
    v-model="model"
    :items="items"
    :search-input.sync="search"
    hide-selected
    multiple
    persistent-hint
    small-chips
    clearable
    outlined
    dense
  >
  </v-combobox>
</template>

<script>
export default {
  name: "SearchBox",
  data() {
    return {
      items: [],
      model: [],
      search: null,
    };
  },
  watch: {
    model() {
      this.$emit("onChange", this.model);
    },
  },
};
</script>

<style scoped>
.search-box >>> input::-webkit-outer-spin-button,
.search-box >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.search-box >>> input[type=number] {
  -moz-appearance: textfield;
}
</style>